export default __webpack_public_path__ + "static/media/icon_cat_AllBands.18a7ab1b.png";